module.exports = __webpack_public_path__ + "img/games.41b63302.svg";